import { useEffect, useState, useContext } from "react"
import { useNavigate } from "react-router-dom"
import { baseUrl } from "../../config/baseUrl"
import axios from "axios"
import loaderContext from "../../context/LoaderContext"
import LibraryOwnerDashboard from "./LibraryOwnerDashboard"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faUsers, faCalendarAlt, faExclamationTriangle, faCheckCircle, faCreditCard, faMoneyBillWave } from "@fortawesome/free-solid-svg-icons"

export default function Dashboard() {
  const navigate = useNavigate()
  const { setLoader } = useContext(loaderContext)
  const [allCount, setAllCount] = useState()
  const [overAll, setOverAll] = useState({})
  const [monthly, setMonthly] = useState({})
  const [slotData, setSlotData] = useState([])
  const [dateRange, setDateRange] = useState({
    fromDate: new Date().toISOString().split("T")[0],
    toDate: new Date().toISOString().split("T")[0],
  })
  const loginUser = JSON.parse(localStorage.getItem("user"))

  useEffect(() => {
    apiCall()
    fetchSlotData()
  }, [])

  const apiCall = async () => {
    try {
      setLoader(true)
      const response = await axios(`${baseUrl}/owner/dashboard/dashboard`, {
        method: "GET",
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      })
      setAllCount(response?.data?.data)
      setOverAll(response?.data?.data?.overallSummary)
      setMonthly(response?.data?.data?.currentMonthSummary)
    } catch (error) {
      console.error("Error fetching dashboard data:", error)
    } finally {
      setLoader(false)
    }
  }

  const fetchSlotData = async () => {
    try {
      const response = await axios.get(`${baseUrl}/owner/dashboard/slotwise`, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      })
      if (response.data.status) {
        setSlotData(response.data.data)
      }
    } catch (error) {
      console.error("Error fetching slot data:", error)
    }
  }

  // Calculate totals from slot data
  // const totalBookings = slotData.reduce((sum, slot) => sum + slot.bookedSeats, 0)
  const totalSeats = slotData.reduce((sum, slot) => sum + slot.numberOfSeats, 0)
  const totalRevenue = slotData.reduce((sum, slot) => sum + slot.bookedSeats * slot.libraryPrice, 0)
  const feesDue = 5 // Mock data - replace with actual API
  const pendingApprovals = 3 // Mock data - replace with actual API

  return (
    <>
      <section className="main-sec">
        <div className="container-fluid">
          <div className="row">
            {/* Header */}
            <div className="col-lg-12">
              <div className="dashboard-header mb-4">
                <div className="d-flex justify-content-between align-items-center">
                  <div>
                    <h4 className="dash-head mb-1 text-white">
                      <i className="fa fa-home me-2" />
                      Library Owner Dashboard
                    </h4>
                    <p className="mb-0 text-dark fw-bold">{allCount?.libraryDetails?.name || "Library Management System"}</p>
                  </div>
                  {/* <div className="date-filter">
                    <div className="row g-2">
                      <div className="col-auto">
                        <label className="form-label small">From Date</label>
                        <input
                          type="date"
                          className="form-control form-control-sm"
                          value={dateRange.fromDate}
                          onChange={(e) => setDateRange((prev) => ({ ...prev, fromDate: e.target.value }))}
                        />
                      </div>
                      <div className="col-auto">
                        <label className="form-label small">To Date</label>
                        <input
                          type="date"
                          className="form-control form-control-sm"
                          value={dateRange.toDate}
                          onChange={(e) => setDateRange((prev) => ({ ...prev, toDate: e.target.value }))}
                        />
                      </div>
                      <div className="col-auto d-flex align-items-end">
                        <button className="btn btn-primary btn-sm">
                          <i className="fa fa-filter me-1"></i>
                          Filter
                        </button>
                      </div>
                    </div>
                  </div> */}
                </div>
              </div>
            </div>
            <div className="row mb-4">
              <div className="col-lg-12">
                <h5>Over All Summary</h5>
              </div>
              <div className="col-lg-12">
                <div className="summary-cards-grid">
                  <div className="summary-card total-revenue">
                    <div className="summary-icon">
                      <FontAwesomeIcon icon={faCalendarAlt} />
                    </div>
                    <div className="summary-content">
                      <h6 className="text-white">Total Bookings</h6>
                      <h4 className="text-white">
                        {overAll?.totalBooking}
                      </h4>
                    </div>
                  </div>
                  <div className="summary-card total-commission">
                    <div className="summary-icon">
                      <FontAwesomeIcon icon={faUsers} />
                    </div>
                    <div className="summary-content">
                      <h6 className="text-white">Total Students</h6>
                      <h4 className="text-white">
                        {overAll?.totalStudents || 0}
                      </h4>
                    </div>
                  </div>
                  <div className="summary-card remaining-amount">
                    <div className="summary-icon">
                      <FontAwesomeIcon icon={faMoneyBillWave} />
                    </div>
                    <div className="summary-content">
                      <h6 className="text-white">Offline Bookings</h6>
                      <h4 className="text-white">
                        {overAll?.offlineBookings}
                      </h4>
                    </div>
                  </div>
                  <div className="summary-card payment-status">
                    <div className="summary-icon">
                      <FontAwesomeIcon icon={faCreditCard} />
                    </div>
                    <div className="summary-content">
                      <h6 className="text-white">Online Bookings</h6>
                      <h4 className="text-white">
                        {overAll?.onlineBookings}
                      </h4>
                    </div>
                  </div>
                  <div className="summary-card remaining-amount">
                    <div className="summary-icon">
                      <FontAwesomeIcon icon={faCheckCircle} />
                    </div>
                    <div className="summary-content">
                      <h6 className="text-white">Confirmed / Pending</h6>
                      <h4 className="text-white">
                        {overAll?.allConfirmBookings} /{" "}
                        {overAll?.allPendingBookings}
                      </h4>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="row mb-4">
              <div className="col-lg-12">
                <h5>Current Month Summary</h5>
              </div>
              <div className="col-lg-12">
                <div className="summary-cards-grid">
                  <div className="summary-card total-revenue">
                    <div className="summary-icon">
                      <FontAwesomeIcon icon={faCalendarAlt} />
                    </div>
                    <div className="summary-content">
                      <h6 className="text-white">Total Bookings</h6>
                      <h4 className="text-white">
                        {monthly?.totalBooking}
                      </h4>
                    </div>
                  </div>
                  <div className="summary-card total-commission">
                    <div className="summary-icon">
                      <FontAwesomeIcon icon={faUsers} />
                    </div>
                    <div className="summary-content">
                      <h6 className="text-white">Total Students</h6>
                      <h4 className="text-white">
                        {monthly?.totalStudents || 0}
                      </h4>
                    </div>
                  </div>
                  <div className="summary-card remaining-amount">
                    <div className="summary-icon">
                      <FontAwesomeIcon icon={faMoneyBillWave} />
                    </div>
                    <div className="summary-content">
                      <h6 className="text-white">Offline Bookings</h6>
                      <h4 className="text-white">
                        {monthly?.offlineBookings}
                      </h4>
                    </div>
                  </div>
                  <div className="summary-card payment-status">
                    <div className="summary-icon">
                      <FontAwesomeIcon icon={faCreditCard} />
                    </div>
                    <div className="summary-content">
                      <h6 className="text-white">Online Bookings</h6>
                      <h4 className="text-white">
                        {monthly?.onlineBookings}
                      </h4>
                    </div>
                  </div>
                  <div className="summary-card remaining-amount">
                    <div className="summary-icon">
                      <FontAwesomeIcon icon={faCheckCircle} />
                    </div>
                    <div className="summary-content">
                      <h6 className="text-white">Confirmed / Pending</h6>
                      <h4 className="text-white">
                        {monthly?.allConfirmBookings} /{" "}
                        {monthly?.allPendingBookings}
                      </h4>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            {/* Dashboard Content */}
            {allCount && slotData.length > 0 && (
              <LibraryOwnerDashboard dashboardData={allCount} slotData={slotData} dateRange={dateRange} />
            )}
          </div>
        </div>
      </section>

      {/* video model */}
      {/* <div
        className="modal fade video"
        id="video-popup"
        tabIndex={-1}
        aria-labelledby="exampleModalLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-dialog-centered modal-lg">
          <div className="modal-content">
            <div className="modal-header">
              <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close" />
            </div>
            <div className="modal-body">
              <iframe
                width="100%"
                height={500}
                src="https://www.youtube.com/embed/yAoLSRbwxL8?si=jQNYMNhkHAWel9v2"
                title="YouTube video player"
                frameBorder={0}
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                referrerPolicy="strict-origin-when-cross-origin"
                allowFullScreen=""
              />
            </div>
          </div>
        </div>
      </div> */}

      <style >{`

      .summary-cards-grid {
            display: grid;
            grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
            gap: 1rem;
          }

          .summary-card {
            background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
            color: white;
            padding: 1.25rem;
            border-radius: 0.5rem;
            display: flex;
            align-items: center;
            gap: 1rem;
            box-shadow: 0 4px 6px rgba(0,0,0,0.1);
            transition: transform 0.2s ease;
          }

          .summary-card:hover {
            transform: translateY(-2px);
          }

          .summary-card.total-revenue {
            background: linear-gradient(135deg, #28a745 0%, #20c997 100%);
          }

          .summary-card.total-commission {
            background: linear-gradient(135deg, #007bff 0%, #6610f2 100%);
          }

          .summary-card.remaining-amount {
            background: linear-gradient(135deg, #ffc107 0%, #fd7e14 100%);
          }

          .summary-card.payment-status {
            background: linear-gradient(135deg, #17a2b8 0%, #6f42c1 100%);
          }

          .summary-icon {
            background: rgba(255,255,255,0.2);
            width: 50px;
            height: 50px;
            border-radius: 50%;
            display: flex;
            align-items: center;
            justify-content: center;
            font-size: 1.25rem;
          }

          .summary-content h6 {
            margin: 0;
            font-size: 0.875rem;
            opacity: 0.9;
            font-weight: 500;
          }

          .summary-content h4 {
            margin: 0;
            font-size: 1.5rem;
            font-weight: 700;
          }

        .dashboard-header {
          background: #26a084;
          color: white;
          padding: 25px;
          border-radius: 12px;
          margin-bottom: 30px;
        }

        .dash-head {
          font-size: 1.8rem;
          font-weight: 700;
          margin: 0;
        }

        .date-filter {
          background: rgba(255, 255, 255, 0.1);
          padding: 15px;
          border-radius: 8px;
          backdrop-filter: blur(10px);
        }

        .date-filter .form-label {
          color: white;
          font-weight: 500;
        }

        .date-filter .form-control {
          background: rgba(255, 255, 255, 0.9);
          border: none;
          border-radius: 6px;
        }

        .owner-dash-card {
          background: white;
          border-radius: 12px;
          padding: 25px;
          box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);
          border: 1px solid #f0f0f0;
          transition: all 0.3s ease;
          height: 140px;
          position: relative;
          overflow: hidden;
        }

        .owner-dash-card::before {
          content: '';
          position: absolute;
          top: 0;
          left: 0;
          right: 0;
          height: 4px;
          background: var(--card-accent);
        }

        .owner-dash-card:hover {
          transform: translateY(-5px);
          box-shadow: 0 8px 30px rgba(0, 0, 0, 0.12);
        }

        .card-content {
          display: flex;
          align-items: center;
          height: 100%;
        }

        .card-icon-wrapper {
          width: 60px;
          height: 60px;
          border-radius: 12px;
          display: flex;
          align-items: center;
          justify-content: center;
          background: var(--card-accent);
          margin-right: 20px;
          flex-shrink: 0;
        }

        .card-icon {
          font-size: 24px;
          color: white;
        }

        .card-details {
          flex: 1;
        }

        .card-number {
          font-size: 2.5rem;
          font-weight: 700;
          color: var(--card-accent);
          margin: 0 0 5px 0;
          line-height: 1;
        }

        .card-label {
          font-size: 1rem;
          font-weight: 600;
          color: #333;
          margin: 0 0 3px 0;
        }

        .card-subtitle {
          font-size: 0.85rem;
          color: #666;
          margin: 0;
        }

        .bookings-card {
          --card-accent: #4f46e5;
        }

        .students-card {
          --card-accent: #059669;
        }

        .fees-card {
          --card-accent: #dc2626;
        }

        .approvals-card {
          --card-accent: #d97706;
        }

        @media (max-width: 768px) {
          .dashboard-header {
            padding: 20px;
          }
          
          .dashboard-header .d-flex {
            flex-direction: column;
            gap: 15px;
          }
          
          .date-filter .row {
            justify-content: center;
          }
          
          .owner-dash-card {
            height: auto;
            padding: 20px;
          }
          
          .card-content {
            flex-direction: column;
            text-align: center;
          }
          
          .card-icon-wrapper {
            margin-right: 0;
            margin-bottom: 15px;
          }
          
          .card-number {
            font-size: 2rem;
          }
        }
          .summary-cards-container .bg-white{
          background: #fff !important;
        }
      `}</style>
    </>
  )
}
